import React, { useState, useEffect } from 'react';
import { Megaphone, X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const AnnouncementBar = () => {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/announcement`)
      .then((r) => r.json())
      .then((data) => {
        if (data.announcement) {
          const key = `avviso-dismissed-${data.announcement.id}`;
          if (!sessionStorage.getItem(key)) {
            setAnnouncement(data.announcement);
          }
        }
      })
      .catch(() => {});
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(`avviso-dismissed-${announcement.id}`, '1');
    setAnnouncement(null);
  };

  if (!announcement) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="max-w-3xl mx-auto mb-8 flex items-start gap-3 bg-white/15 backdrop-blur-md border border-[#F9D424]/40 rounded-xl px-5 py-3 text-left animate-fade-in-up"
    >
      <Megaphone size={18} className="text-[#F9D424] flex-shrink-0 mt-0.5" />
      <p className="text-sm text-white/95 leading-relaxed flex-1">
        <span className="font-semibold text-[#F9D424]">Avviso: </span>
        {announcement.text}
      </p>
      <button
        data-testid="announcement-dismiss-btn"
        onClick={dismiss}
        aria-label="Chiudi avviso"
        className="text-white/60 hover:text-white transition-colors duration-200 flex-shrink-0 mt-0.5"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default AnnouncementBar;
